export const selectTaxonomy = (state) => state.taxonomies.taxonomies;
export const selectTaxonomyList = (state) => state.taxonomies.taxonomiesList;
export const selectTaxonomyLoading = (state) => state.taxonomies.loading;
export const selectTaxonomytError = (state) => state.taxonomies.error
export const selectProcess = (state) => state.taxonomies.process;
